/**
 * Block placement bridge (Faz 5.8) — the HTML5 drag-and-drop path from the
 * Blocks palette onto the drafting canvas. The drop point resolves through
 * the dynamic-input engine's screen→world helper, then the shared placeBlock
 * path runs (undoable, recent-list push).
 */

import { worldAtClient } from '../../core/dynamicInput/dynamicInputEngine';
import { placeBlock } from '../../core/commands/runners/blockCommands';

/** Transfer MIME type carrying the block name across the drag. */
export const BLOCK_MIME = 'application/x-yap-block';

/** Drag start for palette tiles. */
export function onBlockDragStart(e: React.DragEvent, name: string): void {
    e.dataTransfer.setData(BLOCK_MIME, name);
    e.dataTransfer.effectAllowed = 'copy';
}

/** Allow the drop over the drafting canvas. */
export function onBlockDragOver(e: React.DragEvent): void {
    if (e.dataTransfer.types.includes(BLOCK_MIME)) {
        e.preventDefault();
        e.dataTransfer.dropEffect = 'copy';
    }
}

/** Drop: INSERT the carried block at the world point under the cursor. */
export function onBlockDrop(e: React.DragEvent): void {
    const name = e.dataTransfer.getData(BLOCK_MIME);
    if (!name) return;
    e.preventDefault();
    const world = worldAtClient(e.clientX, e.clientY);
    if (!world) return;
    placeBlock(name, [world.x, world.y, world.z]);
}
